module.exports = __webpack_public_path__ + "static/media/excel-nea.d88a1257.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/excel-nea.jpg
 ** module id = 285
 ** module chunks = 0
 **/